import {FirebaseService} from "../firebase/FirebaseService";
import {HelpTypes} from "../../app/components/NeedHelpPopUp";
import {RequestPayload} from "../../app/sites/types/RequestPayload";

/**
 * HelpOfferType of the delivery area
 */
export type DeliveryAreaHelpOffer = {
  helpType: HelpTypes;
  costs: string;
};

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * Service class that contains method for read operations
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 * @constructor
 */
export class ReadAtDatabaseService {
  /**
   * Gets the available HelpOffers for the DeliveryArea
   *
   * @param deliveryArea
   */
  public static async getDeliveryAreaHelpOffer(
    deliveryArea: number
  ): Promise<DeliveryAreaHelpOffer | null> {
    const snapshot = await FirebaseService.dbRef()
      .helpareas()
      .child(String(deliveryArea))
      .once("value");

    if (snapshot.val()) {
      return snapshot.val();
    }

    return null;
  }

  /**
   * Returns a delivery by TrackingID
   *
   * @param trackingID
   */
  public static async getDeliveryByTrackingID(
    trackingID: string
  ): Promise<RequestPayload | null> {
    const snapshot = await FirebaseService.dbRef()
      .deliveries()
      .child(trackingID)
      .once("value");

    if (snapshot.val()) {
      return snapshot.val();
    }

    return null;
  }

  /**
   * Reads the code at the database. When the code does not exists the snapshot would be null
   *
   * @param code
   */
  public static async getAuthenticationCode(code: string): Promise<any> {
    return await FirebaseService.dbRef().codes().child(code).once("value");
  }
}
